import { baseApi } from "api/BaseApi";

import {
  CctlDirectoryEntry,
  CctlListPayload,
  CctlTableEntry,
} from "./cctlDirectory.types";

const DIRECTORY_BASE_URL = "cctl/directory";

export const cctlDirectoryApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    cctlByName: build.query<CctlDirectoryEntry, string | number>({
      query: (cctl_name) => ({
        url: `${DIRECTORY_BASE_URL}/get_frontend_cctl_by_name/`,
        params: { cctl_name },
      }),
    }),

    listCctls: build.query<CctlTableEntry[], CctlListPayload>({
      query: ({ status }) => ({
        url: `${DIRECTORY_BASE_URL}/list_all/`,
        params: status ? { status } : undefined,
      }),
    }),
  }),

  overrideExisting: false,
});

export const { useCctlByNameQuery, useListCctlsQuery } = cctlDirectoryApi;
